
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { EventEmitterService, ModalService, PrecizionServices } from '../../../_services';
import { GridExportsStatesDatas, ApiExportedFileConnectedDeviceModel, GridRowExportStateDatas } from '../../../_models';
import { LoadingService } from '../../../framework/auth/components/loading/loading.service';
import { DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { _IdGenerator } from '@angular/cdk/a11y';

@Component({
  selector: 'export-connected-states',
  templateUrl: './exportconnectedstates.component.html',
  styleUrls: ['./exportconnectedstates.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

// composant interface des états d'envoi de fichiers vers consoles connectées
export class ExportConnectedStatesComponent implements OnInit, OnChanges {
  private _opened: boolean = false;

  // Conposant Kendo UI Grid
  @ViewChild(GridComponent) private gridStates: GridComponent;

  @Output() DialogClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  public gridData: GridDataResult;

  public state: State = {
    skip: 0
  };

  //en cours de chargement
  private _isLoadingStates: boolean = false;

  //indique au front si le bouton de controle de statut est dispo
  public enableCheckButton: boolean = false;

  /**indique que le bouton de maj des derniers statut est disponible 
   * si des statuts en  cours et pas de process de maj en cours
   */
  public get EnabledBtnUpdate(): boolean {
    return (this._isPollingLastStatus == null || this._isPollingLastStatus == false) && this.enableCheckButton == true
  }



  //reprend si niveau service il y a un polling en cours sur la recuperation des derniers statut des fichier
  private _isPollingLastStatus: boolean | null = null;

  /**indique si il est en cours de maj de statut par polling */
  public get isLoadingStatus(): boolean {
    return this._isPollingLastStatus == true;
  }

  public title = "Historique des exports vers les consoles connectées (dernière heure)";
  private _emptyRecordText = "Aucun export connecté";
  public titlePrefix: string = 'Vos exports connectés : ';
  public icDownloadFileTitle: string = "Télécharger le fichier";

  /**texte info affiché en dessous */
  public bannerInfostext: string = '';


  private _gridEmptyText = this._emptyRecordText;
  //#endregion

  ///données du grid de base présente les exploitantion precos
  private _gridStates: GridExportsStatesDatas | null = null;

  @Input()
  set opened(value: boolean) {
    this._opened = value;

    if (value === true) {
      this.LoadingDatas();
      this._precizionService.ChangePopinConnectedStatesOpen(true);
    } else {
      if (this._precizionService.IsPopinConnectedStatesOpen()) {
        this._precizionService.ChangePopinConnectedStatesOpen(false);
      }
    }
  }
  get opened() {
    return this._opened == true
  }

  ///données du grid de base présente
  public get GridConnectedStates() {
    return this.gridData;
  }

  //indique que le chargement des données est en cours
  public get IsLoadingInProgress() {
    return this._isLoadingStates == true;
  }

  //texte à afficher si pas de données grid (selon etat)
  public get EmptyRecordText() {
    return this._gridEmptyText;
  };



  public constructor(private _precizionService: PrecizionServices, private _modalService: ModalService, private _eventEmitterService: EventEmitterService, private _loadingService: LoadingService) {
  }

  ngOnChanges(changes: any) { }
  public ngOnInit() {
    //suppression de la mémoire front des anciens
    //recharge ceux tjs présent en back
    this.Clear();
    this.ReqGetUserLastConnectedExports();
    this.close();
  }

  /**
   * Récupère la liste Back des derniers export connectés présent
   */
  private ReqGetUserLastConnectedExports() {
    this._precizionService.getUserLastConnectedExports(true, true, false).subscribe(
      datas => {
        if (datas && datas.length > 0) {
          if (this._precizionService.ExistExportStateConnectedDevices())
            this.ReqUpdatingLastStates(true, false);
        }
      },
      error => {

      }
    )
  }


  /**
   * Chargement des données
   * maj des statut pour ceux en attente de transfert
   */
  private LoadingDatas() {

    if (this._precizionService.ExistExportStateConnectedDevices()) {
      this.InitGridDatas();
      this.ReqUpdatingLastStates(true, false);
      this.suscribeUpdateOnPollingStatusEnd();
    }
    this.StopChangedStatus();
  }

  /**
   * requetes le dernier etat back de ceux en cours
   * @param _iOnlyProcessStates true que maj de ceux en cours
   * @param _iUpdateProcessState : true il Maj du current statut qui indique SI des exports connectés sont toujours en cours de traitement(transfert envoi)
   */
  private ReqUpdatingLastStates(_iOnlyProcessStates: boolean, _iUpdateProcessState: boolean) {

    let reqUpdateState = this._precizionService.GetParamsRequestConnecteStatesInProgress(_iOnlyProcessStates);
    if (reqUpdateState && reqUpdateState?.requestUids?.length > 0 && this._precizionService.IsPollingLastStatusProcess() == false) {
      this._isLoadingStates = true;
      this.enableCheckButton = false;
      this._precizionService.getStatesSendConnected(reqUpdateState, false, _iUpdateProcessState, _iUpdateProcessState).subscribe(
        (newSUpdateState: ApiExportedFileConnectedDeviceModel[]) => {
          if (newSUpdateState && newSUpdateState?.length > 0) {
            this.UpdateChangedDatas(newSUpdateState);
          }
          this._isLoadingStates = false;

        },
        errors => {
          this._isLoadingStates = false;
        }

      )
    }
  }

  /**
   * Initialise le grid
   */
  private InitGridDatas() {
    this.bannerInfostext = "";
    let memState = this._precizionService.GetMemoryStatesExportConnectedDevices();

    if (memState && memState.Exists() == true) {
      this._gridStates = new GridExportsStatesDatas(memState);
      if (this._gridStates && this._gridStates?.Datas?.length > 0) {
        let memDevices = this._precizionService.GetMemoryRefApiDevices(true);
       
        if (memDevices && memDevices?.Exists() == true) {
          this._gridStates.BindDeviceInfos(memDevices);

        } else {
          
          if (this._precizionService.IsLoadingRefDevicesProcess()) {

            this.bannerInfostext = "Vos consoles n'ont pas encore été chargées."
            this._gridStates.UpdateDeviceMissingStatus(true);
            this.suscribeLoadingUserDevices();
          } else {
            if (this?._gridStates?.Datas?.length > 0) {
              if (this._gridStates.Datas.findIndex(t => t.DeviceMissing == true) > -1) {
                this.bannerInfostext = "Certaines de vos consoles ne sont plus indiquée car supprimées ou désactivées."
              }
            }
          }
        }
      }
      this.BindGridDatas(this._gridStates);
      this.enableCheckButton = this._precizionService.IncludeConnecteStatesInProgress() == true;
    }

  }

  /**
   * Maj du grid pour ceux ayant un statut "en cours"
   */
  private UpdateAfterPollingStatus() {
    if (this._gridStates?.Datas?.length) {

      let reqUidNotFinished = this._gridStates.Datas.filter(t => t.IsInProgress).map(t => t.ReqUid);

      if (reqUidNotFinished?.length > 0) {
        let allMemStates = this._precizionService.GetMemoryStatesExportConnectedDevices();
          
        if (allMemStates && allMemStates?.Exists() == true) {
          let filterStates = allMemStates.Exports.filter(r => r.GetExportRequestUid() != null && reqUidNotFinished.includes(r.GetExportRequestUid() ?? "-") == true);
          if (filterStates?.length > 0) {

            this.UpdateChangedDatas(filterStates);
          }
        }
      }
    }
  }

  /**
   * MAj du grid selon les derniers statut rechargés
   * @param _iUpdateStates dernier status rechargés
   */
  private UpdateChangedDatas(_iUpdateStates: ApiExportedFileConnectedDeviceModel[]) {
    this.enableCheckButton = false;
    if (this._gridStates && this._gridStates.Datas.length > 0) {
      _iUpdateStates.forEach((fNewSate: ApiExportedFileConnectedDeviceModel) => {
        if (fNewSate && fNewSate.Exists()) {
          let ndxFound = this._gridStates?.Datas.findIndex(t => t.ReqUid == fNewSate.GetExportRequestUid()) ?? -1;
          if (ndxFound > -1) {
            this._gridStates?.Datas[ndxFound].UpdateStatus(fNewSate);
          }
        }
      });
      this.BindGridDatas(this._gridStates);
    }

    this.enableCheckButton = this._precizionService.IncludeConnecteStatesInProgress() == true;
    this.StopChangedStatus();
  }

  //souscription sur etat du polling des derniers status d'export de fichier traité en back
  private suscribeUpdateOnPollingStatusEnd() {
    
    this._precizionService.onEndPollingLastStatus().subscribe(
      isPollingEnd => {
        this.UpdateAfterPollingStatus();
        this._isPollingLastStatus = false;
      }
    )
     this._precizionService.onChangeUpdateStatePollingLastStatus().subscribe(
      isPollingNewUpdate => {
        this.UpdateAfterPollingStatus();
      }
    )
    this._precizionService.onStartPollingLastStatus().subscribe(
      isPollingStart => {
        this._isPollingLastStatus = true;
      }
    )
  }

  // souscription sur fin de chargmeent des consoles utilisateur pour maj les infos de consoles
  private suscribeLoadingUserDevices() {

    this._precizionService.WaitEndLoadingRefDevicesInProgress().subscribe(
      isloadingEnd => {
        let memDevices = this._precizionService.GetMemoryRefApiDevices(true);
          if (this._gridStates?.Datas && this._gridStates?.Datas.length > 0) {
            if (memDevices?.Exists() == true) {
              this._gridStates?.BindDeviceInfos(memDevices);
            } else {
              this._gridStates?.UpdateDeviceMissingStatus(false);
            }
          }
          this.bannerInfostext = "";
          this.BindGridDatas(this._gridStates);
      }
    )
  }

  ngOnDestroy(): void {

  }

  //nettoyage des données de la préconisation tech farmer previs chargé
  private Clear() {
    this._gridStates = null;
    this.BindGridDatas(null);
    this.bannerInfostext = "";

  }

  //bind grid 
  private BindGridDatas(_iDatas: GridExportsStatesDatas | null) {
    if (_iDatas && _iDatas.Datas) {
      this.gridData = process(_iDatas.Datas, this.state)
    } else {
      this.gridData = process([], this.state);
    }
  }

  /**
 * Mise à jour des données du tableau (trie)
 * @param state
 */
  public dataStateChange(state: DataStateChangeEvent): void {

    this.state = state;
    if (this._gridStates?.Datas)
      this.gridData = process(this._gridStates?.Datas, this.state);
  }

  /**Fermeture de la modale */
  public close() {
    if (this.opened) {
      this.opened = false;
      this.DialogClosed.emit(this.opened);
    }
  }

  /**
   * Téléchargmeent du fichier epuis l'api si tjs présent
   * @param row 
   */
  public DownloadZipFileClick(row: GridRowExportStateDatas) {
    if (row.ReqUid) {
      let memRow = this._precizionService.GetMemoryStatesExportConnectedDevices();
      if (memRow && memRow?.Exists() == true) {

        let fileDownloadReq = memRow.Exports.find(r => r.GetExportRequestUid() == row.ReqUid);
        if (fileDownloadReq && fileDownloadReq.FileExporting) {
          let errorMsg = "Une erreur est survenue durant le téléchargement du fichier " + fileDownloadReq.FileExporting?.Name;
          this._precizionService.downloadExportedFile(fileDownloadReq.FileExporting).subscribe(p => {
            if (!p) {
              this.UserAlerte(errorMsg);
            }
          },
            error => {
              if (error && error.status && error.status == 400) {
                let errorMsg = `Le fichier «${fileDownloadReq.FileExporting?.Name}» n'est plus disponible en téléchargement !`;
                this.UserAlerte(errorMsg);
              } else {
                this.UserAlerte(errorMsg);
              }

            });
        }
      }
    }
  }

  //sur event fermeture
  public onClose() {
    this.close();
  }

  /**suc clic maj de statut manuel */
  public onReCheckStatusClick() {
    this.ReqUpdatingLastStates(true, true);
  }

  //visualiser le chargement loader
  ShowLoaderWaiting() {
    this._loadingService.show("Merci de patienter durant le chargement des derniers statuts ...");
  }

  /**stop le changement de statut */
  private StopChangedStatus() {
    this._precizionService?.RemoveConnectedStateChanges();
  }

  //dissimuler le loader
  HidLoader() {
    this._loadingService.hide();
  }

  private UserAlerte(_userMessage: string, _iTitle: string = "Téléchargement") {
    this._modalService.Error(_iTitle, _userMessage)

  }
}
